export default __webpack_public_path__ + "img/product-row.661860fc.svg";